const tmj_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Initial ROM and functional limitations",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Inter-incisal distance",
            "title":"",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[
               {
                  "main":"Greater than 34mm",
                  "dbqName":"F[0].Page_3[0].InterIncisalROM[0]",
                  "sub":""
               },
               {
                  "main":"30-34 mm",
                  "dbqName":"F[0].Page_3[0].InterIncisalROM[1]",
                  "sub":""
               },
               {
                  "main":"21-29mm",
                  "dbqName":"F[0].Page_3[0].InterIncisalROM[2]",
                  "sub":""
               },
               {
                  "main":"11-20mm",
                  "dbqName":"F[0].Page_3[0].InterIncisalROM[3]",
                  "sub":""
               },
               {
                  "main":"0-10mm",
                  "dbqName":"F[0].Page_3[0].InterIncisalROM[4]",
                  "sub":""
               }
            ],
            "answer":"0-10mm"
         }
      ]
   },
   {
      "question":"Initial ROM and functional limitations",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right TMJ",
            "title":"Lateral excursion",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[
               {
                  "main":"0 - 4mm",
                  "dbqName":"F[0].Page_3[0].LateralExcursionRLess4[0]",
                  "sub":""
               },
               {
                  "main":"Greater than 4mm",
                  "dbqName":"F[0].Page_3[0].LateralExcursionR[0]",
                  "sub":""
               }
            ],
            "answer":"0 - 4mm"
         },
         {
            "label":"Left TMJ",
            "title":"Lateral excursion",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[               
               {
                  "main":"0 - 4mm",
                  "dbqName":"F[0].Page_3[0].LateralExcursionLLess4[0]",
                  "sub":""
               },
               {
                  "main":"Greater than 4mm",
                  "dbqName":"F[0].Page_3[0].LateralExcursionL[0]",
                  "sub":""
               }
            ],
            "answer":"0 - 4mm"
         }
      ]
   },
   {
      "question":"If ROM is abnormal for ##redHeading##, does it contribute to a functional loss?",
      "redHeading": "Right TMJ",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].YesNo10[1]",
      "dbqName_no":"F[0].Page_3[0].YesNo10[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain",
      "textdbqName":"F[0].Page_3[0].ExplainWhy[1]",
      "textanswer":""
   },
   {
      "question":"If ROM is abnormal for ##redHeading##, does it contribute to a functional loss?",
      "redHeading": "Left TMJ",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].YesNo20[1]",
      "dbqName_no":"F[0].Page_3[0].YesNo20[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain",
      "textdbqName":"F[0].Page_3[0].ExplainWhy[6]",
      "textanswer":""
   },
   {
      "question":"Initial ROM and functional limitations",
      "sub":"Select the best response",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right TMJ",
            "title":"Description of Pain",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[
               {
                  "main":"No pain noted on exam",
                  "dbqName":"F[0].Page_3[0].Right_NoPain[0]",
                  "sub":""
               },
               {
                  "main":"Pain noted on exam on rest/non-movement",
                  "dbqName":"F[0].Page_3[0].Right_PainOnRest[0]",
                  "sub":""
               },
               {
                  "main":"Pain noted on exam but does not result in/cause functional loss",
                  "dbqName":"F[0].Page_3[0].Right_PainNoFunctionalLoss[0]",
                  "sub":""
               },
               {
                  "main":"Pain noted on examination and causes functional loss",
                  "dbqName":"F[0].Page_3[0].Right_PainWithFunctionalLoss[0]",
                  "sub":""
               }
            ],
            "answer":"No pain noted on exam"
         },
         {
            "label":"Left TMJ",
            "title":"Description of Pain",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[
               {
                  "main":"No pain noted on exam",
                  "dbqName":"F[0].Page_3[0].Left_NoPain[0]",
                  "sub":""
               },
               {
                  "main":"Pain noted on exam on rest/non-movement",
                  "dbqName":"F[0].Page_3[0].Left_PainOnRest[0]",
                  "sub":""
               },
               {
                  "main":"Pain noted on exam but does not result in/cause functional loss",
                  "dbqName":"F[0].Page_3[0].Left_PainNoFunctionalLoss[0]",
                  "sub":""
               },
               {
                  "main":"Pain noted on examination and causes functional loss",
                  "dbqName":"F[0].Page_3[0].Left_PainWithFunctionalLoss[0]",
                  "sub":""
               }
            ],
            "answer":"No pain noted on exam"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading## ?",
      "redHeading": "Right TMJ",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "height": "auto",
      "show": true,
      "partial": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "cols": 2,
      "questions":[
         {
            "main":"Mouth opening",
            "dbqName":"F[0].Page_3[0].Right_DorsiflexionPain[0]",
            "answer":"",
         },
         {
            "main":"Right lateral excursion",
            "dbqName":"F[0].Page_3[0].Right_PlantarPain[0]",
            "answer":"",
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         } 
      ],
      "answer":"",
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading## ?",
      "redHeading": "Left TMJ",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "small": true,
      "partial": true,
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "cols": 2,
      "questions":[
         {
            "main":"Mouth opening",
            "dbqName":"F[0].Page_3[0].Left_DorsiflexionPain[0]",
            "answer":"",
         },
         {
            "main":"Left lateral excursion",
            "dbqName":"F[0].Page_3[0].Left_PlantarPain[0]",
            "answer":"",
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         } 
      ],
      "answer":"",
   },
   {
      "question":"Is there evidence of pain with chewing (mastication)",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right TMJ",
            "title":"",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"F[0].Page_3[0].YesNo12[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"F[0].Page_3[0].YesNo12[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left TMJ",
            "title":"",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[               
               {
                  "main":"Yes",
                  "dbqName":"F[0].Page_3[0].YesNo32[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"F[0].Page_3[0].YesNo32[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "INITIAL ROM AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right TMJ",
            "title":"",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"F[0].Page_3[0].YesNo13[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"F[0].Page_3[0].YesNo13[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left TMJ",
            "title":"",
            "subMain":"",
            "sub":"",
            // "defaultVal": "",
            "options":[               
               {
                  "main":"Yes",
                  "dbqName":"F[0].Page_3[0].YesNo33[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"F[0].Page_3[0].YesNo33[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there objective evidence of crepitus for ##redHeading## ?",
      "redHeading": "Right TMJ",
      "sub":"",
      "type":"yesno",
      "show": true,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].YesNo23[1]",
      "dbqName_no":"F[0].Page_3[0].YesNo23[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain",
      "textdbqName":"F[0].Page_3[0].ExplainWhy[3]",
      "textanswer":"",
   },
   {
      "question":"Is there objective evidence of crepitus for ##redHeading## ?",
      "redHeading": "Left TMJ",
      "sub":"",
      "type":"yesno",
      "show": true,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].YesNo34[1]",
      "dbqName_no":"F[0].Page_3[0].YesNo34[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain",
      "textdbqName":"F[0].Page_3[0].ExplainWhy[7]",
      "textanswer":"",
   },
   {
      "question":"Does ##name## require a mechanically altered foods diet, which has been physician verified or documented, due to the temporomandibular disorder?",
      "sub":"If YES, Indicate the restrictions for mechanically altered foods diet",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "DIETARY RESTRICTIONS",
         number: "4"
      },
      "questions":[
         {
            "main":"Yes",
            "dbqName":"F[0].Page_5[0].YesNo36[1]",
            "answer":"",
            "multi": true,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Dietary restrictions to all mechanically altered foods, to include full liquid, puree foods, soft foods, and semi-solid foods",
                  "dbqName":"F[0].Page_5[0].DIETARY1[0]",
                  "answer":""
               },
               {
                  "main":"Dietary restrictions to soft and semi-solid foods",
                  "dbqName":"F[0].Page_5[0].DIETARY3[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"No",
            "dbqName":"F[0].Page_5[0].YesNo36[0]",
            "answer":""
         }           
      ],
      "answer":""
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "dbqName":"F[0].Page_6[0].Remarks[0]",
      "answer":""
   }
 ]

 export default tmj_questions ;
